import axios from 'axios';
import dotenv from 'dotenv';

dotenv.config();

export default axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // baseURL:"http://localhost:9000/api/v1"
});

export const  url=process.env.REACT_APP_BASE_URL;
// export const  url="http://localhost:9000/api/v1";